import { defineRouting } from 'next-intl/routing';

export const locales = ['en', 'fr'] as const;
export const defaultLocale = 'fr' as const;

export const routing = defineRouting({
  locales: locales,
  defaultLocale: defaultLocale,
  localePrefix: 'always', // Always show locale prefix in URL, including default locale
  // hreflang is emitted per page via metadata `alternates` (some pages have per-locale
  // slugs); the middleware's Link header would advertise conflicting alternates.
  alternateLinks: false
});
